module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-down-white-d66be8bd.svg";